
import { defineComponent, ref } from "vue-demi";

export default defineComponent({
  name: "PopupIdentityMismatch",
  components: {
    NewConfirmPopup: () => import("@/modules/Documents/NewConfirmPopup.vue"),
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["update:modelValue", "ok", "cancel"],

  setup(props, { emit }) {
    const isConfirmed = ref(false);

    function close() {
      emit("update:modelValue", false);
    }

    function onOk() {
      emit("ok");

      close();
    }

    function onCancel() {
      emit("cancel");

      close();
    }

    return {
      onCancel,
      onOk,
      isConfirmed,
    };
  },
});
